import { OrderLine, PoOrderDetailsResponse } from '@zonofi/zono-money-store';

export const patchRemovedOrderLines = (
  responseData: any,
  setData: React.Dispatch<
    React.SetStateAction<PoOrderDetailsResponse | undefined>
  >
) => {
  if (responseData?.orderLines && responseData?.order) {
    const removedVariantIds = responseData.orderLines.map(
      (line: OrderLine) => line.productVariantId
    );

    setData((prevData) => {
      if (!prevData) return prevData;

      const updatedOrder = responseData.order;

      return {
        ...prevData,
        total: updatedOrder.total ?? prevData.total,
        skuCount: updatedOrder.skuCount ?? prevData.skuCount,
        lines: prevData.lines.filter(
          (line) => !removedVariantIds.includes(line.productVariantId)
        ),
      };
    });
  }
};
